import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row } from 'react-bootstrap'
import { useParams } from 'react-router-dom';
import AuthService from "../controllers/AuthService";
import UserService from "../controllers/UserService";
import MultiCarouselPage from './MultiCarouselPage';
import $ from 'jquery'
import FriendshipGame from "./Game/FriendshipGame";

const CardActivity = props => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [roomId, setRoomId] = useState('');
  const [roomList, setRoomList] = useState([]);
  const [selection, setSelection] = useState(null);
  const [yearTermSelection, setYearTermSelection] = useState(null);
  const [styleFilter, setStyleFilter] = useState('');
  const [styleReport, setStyleReport] = useState('');
  const [styleEmpty, setStyleEmpty] = useState('d-none');

  const search = window.location.search;
  const params = new URLSearchParams(search);
  let currentY = params.get('qyear') || '0';
  let currentT = params.get('qterm') || '0';
  let currentRoom = params.get('qroom') || '0';
  let teacherInRoom = null;

  var qString = '';
  useEffect(() => {

    setIsLoaded(true);
    let result;
    const user = AuthService.getCurrentUser();
    const userId = AuthService.getCurrentUserId();
    const userFeature = AuthService.getCurrentUserFeatures();

    UserService.distinctYearTerm().then((response) => {
      response.data.data = response.data.data.reverse();
      if (AuthService.getUserRole() !== 'student' && AuthService.getUserRole() !== 'teacher') {
        if (currentY === '0' && response.data.data && response.data.data[0] && response.data.data[0].year) {
          currentY = response.data.data[0].year;
        }

        if (currentT === '0' && response.data.data && response.data.data[0] && response.data.data[0].term) {
          currentT = response.data.data[0].term;
        }
        console.log('**************************');
        console.log(currentT);
      } else {
        currentY = currentY === '0' ? AuthService.getUserCurrentYear() : currentY;
        currentT = currentT === '0' ? AuthService.getUserCurrentTerm() : currentT;
      }

      let yTS = []
      var stringQ = '';
      var ytText = '';
      // start
      for (const [key, value] of Object.entries(response.data.data)) {
        stringQ = '?qyear=' + response.data.data[key].year + '&qterm=' + response.data.data[key].term;
        if (AuthService.getUserRole() === 'headmaster' || AuthService.getUserRole() === 'student') {
          stringQ += '&qroom=';
        }
        ytText = response.data.data[key].term + '/' + response.data.data[key].year;
        const ss = (String(currentY) === String(response.data.data[key].year) && String(currentT) === String(response.data.data[key].term)) ? true : false;
        yTS.push({
          value: stringQ,
          text: ytText,
          selected: ss,
        })
      };
      setYearTermSelection(yTS)

      // end

    }).then(() => {

      if (typeof user.room !== 'undefined') {
        var focusRoomId = user.room.id;
      } else {
        var focusRoomId = currentRoom;
      }

      UserService.getFriendshipReportList2(focusRoomId).then(
        (res) => {

          // if(res !== null){
          //   for (const [index, value] of res.data.data.entries()) {

          //     if(value.user.roles[0].toLowerCase() === 'teacher' && teacherInRoom === null) { 
          //       teacherInRoom = value.user.id;
          //     }            
          //   }		
          // }               			

        }).then(() => {
          if (props.action === 'activity') {
            setStyleReport('d-none');
            setStyleEmpty('d-none');
            if (AuthService.getUserRole() === 'student') {
              result = [];
              if (userFeature && userFeature.includes('friendship')) {
                setStyleFilter('d-none');
                result = [
                  {
                    'description': 'คนทุกคนล้วนมีคุณค่าในตัวเอง มาร่วมกันสื่อสารคุณค่าที่มีอยู่ในตัวเรา <span class="doNotWrap">และคนรอบข้าง</span>ให้สัมผัสถึงคุณค่าเชิงบวกของตัวเอง',
                    'image': '/images/card/friendship.jpg',
                    'link': '/evaluate/' + user.room.id,
                    'btnText': 'friendship'.toUpperCase(),
                    'id': '',
                  }
                  //homeroom only
                ];

              }

              if (userFeature && userFeature.includes('riasec')) {
                result.push({
                  'description': 'แบบวัดเพื่อสำรวจบุคลิกภาพและความสนใจทางอาชีพ (RIASEC)',
                  'image': '/images/riasec/riasec.jpg',
                  // 'link': '/riasec/evaluate/'+ user.id,
                  'link': '/riasec/qr-code',
                  'btnText': 'riasec'.toUpperCase(),
                  'id': '',
                })
              }

              setItems(result);
            } else if (AuthService.getUserRole() === 'teacher') {
              setStyleFilter('d-none');
              // if( teacherInRoom === userId ){
              result = [];
              if (userFeature && userFeature.includes('homeroom')) {
                result.push({
                  'description': 'มาร่วมกันค้นหาคุณค่าผ่าน<span class="doNotWrap">นิสัยเชิงบวก</span>จากเรื่องราวที่สร้าง<span class="doNotWrap">แรงบันดาลใจ</span>ของคนทั่วโลก',
                  'image': '/images/card/homeroom_new.jpg',
                  'link': '/homeroom',
                  'btnText': 'homeroom'.toUpperCase(),
                  'id': '',
                })
              }
              if (userFeature && userFeature.includes('friendship')) {
                result.push({
                  'description': 'คนทุกคนล้วนมีคุณค่าในตัวเอง มาร่วมกันสื่อสารคุณค่าที่มีอยู่ในตัวเรา <span class="doNotWrap">และคนรอบข้าง</span>ให้สัมผัสถึงคุณค่าเชิงบวกของตัวเอง',
                  'image': '/images/card/friendship.jpg',
                  'link': '/evaluate',
                  'btnText': 'friendship'.toUpperCase(),
                  'id': ''

                })
                // }


                if (userFeature && userFeature.includes('riasec')) {
                  result.push({
                    'description': 'แบบวัดเพื่อสำรวจบุคลิกภาพและความสนใจทางอาชีพ (RIASEC)',
                    'image': '/images/riasec/riasec.jpg',
                    'link': '/riasec/' + user.room.id,
                    'btnText': 'riasec'.toUpperCase(),
                    'id': ''
                  })
                }

              }
              else {

                if (userFeature && userFeature.includes('homeroom')) {
                  result = [
                    {
                      'description': 'มาร่วมกันค้นหาคุณค่าผ่าน<span class="doNotWrap">นิสัยเชิงบวก</span>จากเรื่องราวที่สร้าง<span class="doNotWrap">แรงบันดาลใจ</span>ของคนทั่วโลก',
                      'image': '/images/card/homeroom_new.jpg',
                      'link': '/homeroom',
                      'btnText': 'homeroom'.toUpperCase(),
                      'id': '',
                    }
                  ];
                }

                if (userFeature && userFeature.includes('riasec')) {
                  result.push({
                    'description': 'แบบวัดเพื่อสำรวจบุคลิกภาพและความสนใจทางอาชีพ (RIASEC)',
                    'image': '/images/riasec/riasec.jpg',
                    'link': '/riasec/' + user.room.id,
                    'btnText': 'riasec'.toUpperCase(),
                    'id': '',
                  })
                }
              }
            }
            setItems(result);
          } else {

            //Report
            // console.log(user);
            var temp_description = 'มาร่วมกันค้นหาคุณค่าผ่าน<span class="doNotWrap">นิสัยเชิงบวก</span>จากเรื่องราวที่สร้าง<span class="doNotWrap">แรงบันดาลใจ</span>ของคนทั่วโลก';
            var temp_image = '/images/card/homeroom_new.jpg';
            var temp_link = '/report/overview/';
            var temp_btnText = 'ดูรายงาน';



            if (AuthService.getUserRole() === 'student') {
              setStyleFilter('d-none');
              setSelection(null);

              UserService.getActivities({
                limit: 1,
                domain: user.domain.name,
                studentId: user.id,
                year: currentY === '0' ? AuthService.getUserCurrentYear() : currentY,
                term: currentT === '0' ? AuthService.getUserCurrentTerm() : currentT
              }).then((res) => {

                if (currentY === '0' && currentT === '0') {
                  setRoomId(user.room.id);
                  currentRoom = user.room.id;
                }

                if (!currentRoom || currentRoom === '0' || parseInt(currentRoom) === 0) {
                  setRoomId(user.room.id);
                  currentRoom = user.room.id;
                }

                result = [];
                if (currentRoom == 0) {
                  hideAllFeature();
                }

                if (userFeature && userFeature.includes('homeroom')) {
                  result.push({
                    'description': temp_description,
                    'image': temp_image,
                    'link': temp_link + currentRoom,
                    'btnText': temp_btnText,
                    'id': 'url-Link',
                  })
                }
                if (userFeature && userFeature.includes('friendship')) {
                  result.push({
                    'description': 'คนทุกคนล้วนมีคุณค่าในตัวเอง <span class="doNotWrap">มาร่วมกัน</span>สื่อสารคุณค่าที่มีอยู่ในตัวเรา <span class="doNotWrap">และคนรอบข้าง</span>ให้สัมผัสถึงคุณค่าเชิงบวกของตัวเอง',
                    'image': '/images/card/friendship.jpg',
                    'link': '/report/friendship/' + currentRoom,
                    'btnText': temp_btnText,
                    'id': 'url-Friendship',
                  })
                }


                if (userFeature && userFeature.includes('riasec')) {
                  result.push({
                    'description': 'แบบวัดเพื่อสำรวจบุคลิกภาพและความสนใจทางอาชีพ (RIASEC)',
                    'image': '/images/riasec/riasec.jpg',
                    'link': '/report/riasec/' + currentRoom + '/' + userId,
                    'btnText': temp_btnText,
                    'id': 'url-riasec',
                  })
                }

                setItems(result);
              });



            } else if (AuthService.getUserRole() === 'teacher') {

              setStyleFilter('d-none');
              setSelection(null);

              if (currentY === '0' && currentT === '0') {
                setRoomId(user.room.id);
                currentRoom = user.room.id;
              }

              if (!currentRoom || currentRoom === '0' || parseInt(currentRoom) === 0) {
                setRoomId(user.room.id);
                currentRoom = user.room.id;
              }


              result = [];
              if (currentRoom == 0) {
                hideAllFeature();
              }

              if (userFeature && userFeature.includes('homeroom')) {
                result.push({
                  'description': temp_description,
                  'image': temp_image,
                  'link': temp_link + currentRoom, ///report/overview/602d40e3dc2fdf0289337c3e
                  'btnText': temp_btnText,
                  'id': 'url-Link',
                })
              }
              if (userFeature && userFeature.includes('friendship')) {
                result.push({
                  'description': 'คนทุกคนล้วนมีคุณค่าในตัวเอง มาร่วมกัน สื่อสารคุณค่าที่มีอยู่ในตัวเรา และคนรอบ\nข้างให้สัมผัสถึงคุณค่าเชิงบวกของตัวเอง',
                  'image': '/images/card/friendship.jpg',
                  'link': '/report/friendship/' + currentRoom,  //report/friendship/60c0e14221965c37a7c1b75f
                  'btnText': 'ดูรายงาน',
                  'id': 'url-Friendship',
                  'csvId': 'csv-id-friendship',
                  'csvLink': `${process.env.REACT_APP_API_ENDPOINT}/api/` + "rooms/" + currentRoom + "/friendship-status/export"
                })
              }
              if (userFeature && userFeature.includes('pocket-book')) {
                result.push({
                  'description': 'สมุดพกที่จะเปลี่ยนคำนิยามเดิมๆ เกี่ยวกับคุณค่า และอุปนิสัยเชิงบวกของนักเรียน',
                  'image': '/images/card/pocketbook.jpg',
                  'link': '/pocketbook/' + currentRoom,
                  'btnText': temp_btnText,
                  'id': 'url-pocketbook',
                })
              }

              if (userFeature && userFeature.includes('riasec')) {
                result.push({
                  'description': 'แบบวัดเพื่อสำรวจบุคลิกภาพและความสนใจทางอาชีพ (RIASEC)',
                  'image': '/images/riasec/riasec.jpg',
                  'link': '/report/riasec/' + currentRoom,
                  'btnText': temp_btnText,
                  'id': 'url-riasec',
                  'csvId': 'csv-id-riasec',
                  'csvLink': `${process.env.REACT_APP_API_ENDPOINT}/api/` + "rooms/" + currentRoom + "/riasec-status/export"
                })
              }

              setItems(result);

            } else {


              UserService.getRoomList({ id: user.id, domain: user.domain.name, term: currentT, year: currentY }).then(
                (res) => {

                  if (res.data.data !== [] && res.data.data.length !== 0) {
                    setRoomList(res.data.data);
                    // console.log(currentRoom, res.data.data[0].id);       
                    if (currentRoom === '0' && res.data.data && res.data.data[0] && res.data.data[0].id) {
                      // console.log('test');
                      setRoomId(res.data.data[0].id);
                      currentRoom = res.data.data[0].id;
                    } else {
                      setRoomId(currentRoom);
                    }

                    let roomS = []
                    var stringQ = '';
                    var roomText = '';
                    // start
                    for (const [key, value] of Object.entries(res.data.data)) {

                      stringQ = res.data.data[key].id;
                      roomText = res.data.data[key].displayName;
                      const ss = (String(res.data.data[key].id) === String(currentRoom)) ? 'selected' : '';
                      console.log(stringQ, roomText, ss);
                      roomS.push({
                        value: stringQ,
                        text: roomText,
                        selected: ss,
                      })
                    };
                    setSelection(roomS)

                    // make sure select correct year            
                    var tempYY = '?qyear=' + currentY + '&qterm=' + currentT + '&qroom=';
                    $('#selectYearTerm').val(tempYY);

                    return currentRoom;
                  } else {
                    setSelection(null);

                  }

                  return '';
                },
                (error) => {
                  //   console.log(resMessage);
                }
              ).then(
                (res) => {
                  result = [];

                  if (res == 0) {
                    hideAllFeature();
                  }
                  if (userFeature && userFeature.includes('homeroom')) {
                    result.push({
                      'description': temp_description,
                      'image': temp_image,
                      'link': temp_link + res, ///report/overview/602d40e3dc2fdf0289337c3e
                      'btnText': temp_btnText,
                      'id': 'url-Link',
                    })
                  }
                  if (userFeature && userFeature.includes('friendship')) {
                    result.push({
                      'description': 'คนทุกคนล้วนมีคุณค่าในตัวเอง มาร่วมกัน สื่อสารคุณค่าที่มีอยู่ในตัวเรา และคนรอบ\nข้างให้สัมผัสถึงคุณค่าเชิงบวกของตัวเอง',
                      'image': '/images/card/friendship.jpg',
                      'link': 'report/friendship/' + res,  //report/friendship/60c0e14221965c37a7c1b75f
                      'btnText': 'ดูรายงาน',
                      'id': 'url-Friendship',
                      'csvId': 'csv-id-friendship',
                      'csvLink': `${process.env.REACT_APP_API_ENDPOINT}/api/` + "rooms/" + res + "/friendship-status/export"
                    })
                  }
                  if (userFeature && userFeature.includes('pocket-book')) {
                    result.push({
                      'description': 'สมุดพกที่จะเปลี่ยนคำนิยามเดิมๆ เกี่ยวกับคุณค่า และอุปนิสัยเชิงบวกของนักเรียน',
                      'image': '/images/card/pocketbook.jpg',
                      'link': '/pocketbook/' + res,
                      'btnText': temp_btnText,
                      'id': 'url-pocketbook',
                    })
                  }

                  if (userFeature && userFeature.includes('riasec')) {
                    result.push({
                      'description': 'แบบวัดเพื่อสำรวจบุคลิกภาพและความสนใจทางอาชีพ (RIASEC)',
                      'image': '/images/riasec/riasec.jpg',
                      'link': '/report/riasec/' + res,
                      'btnText': temp_btnText,
                      'id': 'url-riasec',
                      'csvId': 'csv-id-riasec',
                      'csvLink': `${process.env.REACT_APP_API_ENDPOINT}/api/` + "rooms/" + res + "/riasec-status/export"
                    })
                  }
                  setItems(result);


                }
              );
            }
          }
        });

    });
  }, [])


  const exportLink = (link) => {
    if (link) {
      window.open(link, '_blank').focus();
    }
  }


  const handleChaangRoom = (e) => {
    const roomValue = $('#selectRoom').val()
    var ytValue = $('#selectYearTerm').val();

    if (ytValue && roomValue) {
      var paramString = ytValue + roomValue;
      var url = window.location.href.split('?')[0] + paramString;
      window.location.href = url;
    } else {
      console.log('กรุณาเลือกห้องและปีการศึกษา');
    }

  }

  const hideAllFeature = (link) => {
    $('#url-Link').hide();
    $('#url-Friendship').hide();
    $('#url-pocketbook').hide();
    $('#url-riasec').hide();
    $('.card-report').hide();
    setStyleEmpty('');
    $('.pocketbook').hide();
  }

  const handleChangeYearTerm = (e) => {
    const val = $('#selectYearTerm').val()
    console.log(val)
    // console.log(qString); 
    const currentUserDetail = AuthService.getCurrentUser();

    if (qString !== val) {
      qString = val;
      var ytValue = val;

      if (AuthService.getUserRole() === 'student') {
        if (roomId !== '0' && ytValue) {
          var urlParams = new URLSearchParams(ytValue);
          UserService.getRoomByTeamYearUser({
            limit: 1,
            domain: currentUserDetail.domain.name,
            studentId: currentUserDetail.id,
            year: urlParams.get('qyear'),
            term: urlParams.get('qterm')
          }).then((res) => {

            if (res.data && res.data.data && res.data.data[0] && res.data.data[0].id) {
              var paramString = ytValue + res.data.data[0].id;
              var url = window.location.href.split('?')[0] + paramString;
              window.location.href = url;
            } else {
              $('#url-Link').hide();
              $('#url-Friendship').hide();
              $('#csv-id-friendship').hide();
              $('.pocketbook').hide();
              $('.card-report').hide();
              setStyleEmpty('');
            }


          });

        } else {
          alert('พบความผิดพลาดกรุณาติดต่อเจ้าหน้าที่');
          $('#url-Link').hide();
          $('#url-Friendship').hide();
          $('#csv-id-friendship').hide();
          $('.pocketbook').hide();
          $('.card-report').hide();
          setStyleEmpty('');

        }

      }
      else if (AuthService.getUserRole() === 'teacher') {
        var urlParams = new URLSearchParams(ytValue);
        UserService.getRoomByTeamYearUser({
          limit: 1,
          domain: currentUserDetail.domain.name,
          teacherId: currentUserDetail.id,
          year: urlParams.get('qyear'),
          term: urlParams.get('qterm')
        }).then((res) => {

          if (res.data && res.data.data && res.data.data[0] && res.data.data[0].id) {

            // console.log(res);              

            var paramString = ytValue + '&qroom=' + res.data.data[0].id;
            var url = window.location.href.split('?')[0] + paramString;
            // console.log(ytValue,res.data.data[0].id);  
            // console.log(url);
            window.location.href = url;


          } else {
            //disable button              
            $('#url-Link').hide();
            $('#url-Friendship').hide();
            $('#csv-id-friendship').hide();
            $('#url-pocketbook').hide();
            $('#url-riasec').hide();
            $('#csv-id-riasec').hide();
            $('.card-report').hide();
            $('.pocketbook').hide();
            setStyleEmpty('');
            // alert('ไม่พบห้องในปีการศึกษาที่เลือกกรุณาตรวจสอบกับผู้ดูแลระบบ');
          }


        });

      } else {

        var urlParams = new URLSearchParams(ytValue);
        UserService.getRoomList({ id: currentUserDetail.id, domain: currentUserDetail.domain.name, term: urlParams.get('qterm'), year: urlParams.get('qyear') }).then(
          (res) => {
            if (res.data.data !== [] && res.data.data.length !== 0) {
              setRoomList(res.data.data);

              let roomS = []
              var stringQ = '';
              var roomText = '';
              // start
              for (const [key, value] of Object.entries(res.data.data)) {

                stringQ = res.data.data[key].id;
                roomText = res.data.data[key].displayName;
                const ss = (key == 0) ? 'selected' : '';
                console.log(stringQ, roomText, ss);
                roomS.push({
                  value: stringQ,
                  text: roomText,
                  selected: ss,
                })
              };
              setSelection(roomS)

            }

            return true;
          },
          (error) => {
            return false;
          }
        ).then(
          (statusRoom) => {

            var roomValue = $('#selectRoom').val();
            if (ytValue && roomValue) {
              var urlParams = new URLSearchParams(ytValue);
              UserService.getRoomByTeamYearUser({
                limit: 1,
                domain: currentUserDetail.domain.name,
                year: urlParams.get('qyear'),
                term: urlParams.get('qterm')
              }).then((res) => {

                if (res.data && res.data.data && res.data.data[0] && res.data.data[0].id) {

                  var paramString = ytValue + roomValue;
                  var url = window.location.href.split('?')[0] + paramString;
                  window.location.href = url;

                } else {
                  hideAllFeature();
                }

              });
            } else {
              hideAllFeature();

            }
          });

      }
    }

  };
  
  let allData = [];
  const responsive2 = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3,
        partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
    },
    tablet: {
        breakpoint: { max: 1024, min: 500 },
        items: 2,
        partialVisibilityGutter: 50 // this is needed to tell the amount of px that should be visible.
    },
    mobile: {
        breakpoint: { max: 500, min: 0 },
        items: 1,
        partialVisibilityGutter: 50 // this is needed to tell the amount of px that should be visible.
    }
}

const responsive3 = {
  desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      // partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
  },
  tablet: {
      breakpoint: { max: 1024, min: 500 },
      items: 2,
      partialVisibilityGutter: 50 // this is needed to tell the amount of px that should be visible.
  },
  mobile: {
      breakpoint: { max: 500, min: 0 },
      items: 1,
      partialVisibilityGutter: 50 // this is needed to tell the amount of px that should be visible.
  }
}

  let html = (
    <Row id="card-section">
      {

        (typeof items !== 'undefined') ? (

          (items).map((item, i) => {
            // console.log(item)

            let cardDetail = <Col key={'activity_' + i} className="px-md-0  d-flex align-items-stretch">
            <Card className="mx-lg-3 my-2 border-radius-125 no-border-line activity-card" >
              <Card.Img variant="top" src={item.image} className="border-radius-top-125" />
              <Card.Body className="d-flex flex-column">
                <Card.Title> <h4 className="card-description py-1">
                  <div dangerouslySetInnerHTML={{ __html: item.description }} />
                  {/* {item.description.split('\n').map((item, key) => {
                  return <span key={key}>{item}<br/></span>
                })} */}
                </h4>
                  <div className="text-center">
                    {item.csvLink ? (

                      <span id={item.csvId} onClick={() => exportLink(item.csvLink)}> <u className="t-14 text-green-evaluate click-pointer font-sarabun" >ดาวน์โหลดข้อมูล .CSV</u></span>
                    ) : (
                      ''
                    )}
                  </div>
                </Card.Title>

                <div className="mt-auto">
                  {item.onClick ? (
                    <span id={item.id} onClick={() => exportLink(item.onClick)}> <button className="btn bluesky card-btn" >{item.btnText} </button></span>
                  ) : (
                    <a id={item.id} href={item.link}> <button className="btn bluesky card-btn" >{item.btnText} </button></a>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>

          allData.push(cardDetail);
            // return (
            //   <Col key={'activity_' + i} lg="4" className="px-md-0  d-flex align-items-stretch">
            //     <Card className="mx-3 my-2 border-radius-125 no-border-line activity-card" >
            //       <Card.Img variant="top" src={item.image} className="border-radius-top-125" />
            //       <Card.Body className="d-flex flex-column">
            //         <Card.Title> <h4 className="card-description py-1">
            //           <div dangerouslySetInnerHTML={{ __html: item.description }} />
            //           {/* {item.description.split('\n').map((item, key) => {
            //           return <span key={key}>{item}<br/></span>
            //         })} */}
            //         </h4>
            //           <div className="text-center">
            //             {item.csvLink ? (

            //               <span id={item.csvId} onClick={() => exportLink(item.csvLink)}> <u className="t-14 text-green-evaluate click-pointer font-sarabun" >ดาวน์โหลดข้อมูล .CSV</u></span>
            //             ) : (
            //               ''
            //             )}
            //           </div>
            //         </Card.Title>

            //         <div className="mt-auto">
            //           {item.onClick ? (
            //             <span id={item.id} onClick={() => exportLink(item.onClick)}> <button className="btn bluesky card-btn" >{item.btnText} </button></span>
            //           ) : (
            //             <a id={item.id} href={item.link}> <button className="btn bluesky card-btn" >{item.btnText} </button></a>
            //           )}
            //         </div>
            //       </Card.Body>
            //     </Card>
            //   </Col>)
          }
          )) : (
          <div></div>
        )

      }
      
      <MultiCarouselPage data={allData}  responsive={allData.length > 3 ? responsive2 : responsive3} />    
    </Row>
  );


  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return <div>Loading...</div>;
  } else {
    // console.log('items')
    // console.log(items)
    return (
      <div>
        <Row className={`${styleReport}`}>
          <Col className="col-12 col-md-12 mb-4 d-flex">
            <div className="d-flex">
              <label className="text--white text-left mb-0 pr-2 font-sarabun-bold" style={{ "padding": ".25rem .5rem", "width": "150px" }}>ปีการศึกษา</label>
              <select id="selectYearTerm" class="form-control form-control-sm border-radius-5 w-100 font-sarabun" onChange={(e) => handleChangeYearTerm()}>
                {
                  (yearTermSelection && yearTermSelection.length > 0) ? (
                    yearTermSelection.map((item, index) => (
                      <option value={item.value} selected={item.selected}>{item.text}</option>
                    ))
                  ) : (
                    <span className='d-none' />
                  )
                }
              </select>
            </div>

            <div className="d-flex">
              <label className={`${styleFilter} text--white text-left mb-0 pr-2 font-sarabun-bold`} style={{ "padding": ".25rem .5rem" }}>ห้อง</label>
              <div className={`${styleFilter}`}>
                <select id="selectRoom" class="form-control form-control-sm border-radius-5 w-100 font-sarabun" onChange={(e) => handleChaangRoom()}>
                  {
                    (selection && selection.length > 0) ? (
                      selection.map((item, index) => (
                        <option value={item.value} selected={item.selected}>{item.text}</option>
                      ))
                    ) : (
                      <span className='d-none' />
                    )
                  }
                </select>
              </div>
            </div>
          </Col>

          <Col>
            <div className={`${styleEmpty} col-12`}>
              <h3 className="text--white mt-3">คุณไม่มีข้อมูลกิจกรรรมในภาคการศึกษานี้</h3>
            </div>
          </Col>
        </Row>

        <div className="card-report">
          {html}
        </div>

        {/* <Row>
          <Col>
            <FriendshipGame />
          </Col>
        </Row> */}
      </div>
    );
  }
}

export default CardActivity

